import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
  {
    code: 'de',
    name: 'Deutsch',
    flag: '🇩🇪'
  },
  {
    code: 'en',
    name: 'English',
    flag: '🇬🇧'
  }
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLanguageChange = (langCode: string) => {
    i18n.changeLanguage(langCode);
    setIsOpen(false);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-slate-100 transition-colors cursor-pointer group"
        aria-label="Language Switcher"
      >
        <span className="text-2xl">{currentLanguage.flag}</span>
        <i className={`ri-arrow-down-s-line text-lg text-slate-500 group-hover:text-[#0F172A] transition-all duration-200 ${isOpen ? 'rotate-180' : ''}`}></i>
      </button>

      {isOpen && (
        <div className="absolute top-full right-0 mt-2 bg-white/95 backdrop-blur-xl rounded-xl shadow-lg border border-slate-200 py-2 min-w-[160px] z-50 animate-fade-in-up">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => handleLanguageChange(lang.code)}
              className={`w-full flex items-center gap-3 px-4 py-3 hover:bg-slate-50 transition-colors cursor-pointer ${currentLanguage.code === lang.code ? 'bg-gradient-to-r from-[#10B981] to-[#1E3A8A]' : ''
                }`}
            >
              <span className="text-2xl">{lang.flag}</span>
              <span
                className={`text-sm font-medium ${currentLanguage.code === lang.code ? 'text-white' : 'text-slate-600'}`}
                style={{ fontFamily: 'DM Sans, sans-serif' }}
              >
                {lang.name}
              </span>
              {currentLanguage.code === lang.code && (
                <i className="ri-check-line text-white ml-auto"></i>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
